export const en = {
  title: "Preferences",
  pageTitle: "Preferences",
  subtitle: "Manage your workspace settings and configurations",
  pageSubtitle: "Manage your workspace settings and configurations",
  metaTitle: "Preferences - OrderHub",
  metaDescription: "Manage your workspace settings and configurations.",
  breadcrumb: "Preferences",
  workspace: {
    title: "Workspace Name",
    description: "Rename your team workspace",
    nameLabel: "Workspace name",
    nameHelper: "This appears across the app and in notifications",
    save: "Save Name",
    saved: "Workspace name updated",
    saveError: "Failed to update workspace name",
    nameRequired: "Workspace name cannot be empty",
  },
  display: {
    title: "Display",
    description: "Regional and formatting preferences",
    language: { label: "Language", helper: "Interface and email language for this workspace" },
    timeZone: { label: "Time Zone", helper: "Used across the application for timestamps" },
    dateFormat: { label: "Date Format", helper: "How dates are displayed throughout the app" },
    timeFormat: { label: "Time Format", helper: "How times are displayed throughout the app" },
    timeFormat12h: "12-hour (1:30 PM)",
    timeFormat24h: "24-hour (13:30)",
    save: "Save Display",
  },
  thresholds: {
    title: "Activity Thresholds",
    description: "Overdue and high-value detection rules",
    save: "Save Thresholds",
    overdue: {
      label: "Overdue Threshold (minutes)",
      helper: "Activities older than this are marked overdue",
    },
    highValue: {
      label: "High-Value Threshold",
      helper: "Activities above this value are flagged as high-value",
    },
  },
  notifications: {
    title: "Email Notifications",
    description: "Control which emails you receive",
    active: "{{active}}/{{total}} active",
    changesSaveAutomatically: "Changes save automatically",
  },
  vip: {
    title: "VIP Classification",
    description: "Auto-classify customers based on spending behavior",
    enabled: "Enabled",
    disabled: "Disabled",
    save: "Save VIP Settings",
    lifetimeSalesLabel: "Lifetime Sales ≥",
    lifetimeSalesPlaceholder: "e.g. 10000",
    completedOrdersLabel: "Completed Orders ≥",
    completedOrdersPlaceholder: "e.g. 25",
    conjunctionAnd: "AND",
    qualifyNotice: "Customers qualify when both conditions are met simultaneously. Set either to 0 to disable auto-classification.",
    toastSaved: "VIP settings saved",
    toastSavedDescription: "Customer re-classification is running in the background.",
    lifetimeSalesRangeError: "Lifetime sales must be between {{min}} and {{max}}.",
    completedOrdersRangeError: "Completed orders must be between {{min}} and {{max}}.",
  },
  saved: "Preferences saved.",
  saveFailed: "Failed to save preferences. Please try again.",
  whatsapp: {
    cardHeader: "WhatsApp Templates",
    cardDescription: "Customize the header and message used when opening WhatsApp from an activity",
    headerLabel: "Header",
    headerPlaceholder: "e.g. Order Confirmation",
    messageLabel: "Message",
    messagePlaceholder: "Hi {{customer_name}}, ...",
    variablesHint: "Available variables: {{customer_name}}, {{order_number}}, {{order_items}}, {{amount}}, {{currency}}, {{checkout_url}}",
    save: "Save WhatsApp Templates",
    saved: "WhatsApp templates saved.",
    saveError: "Failed to save WhatsApp templates.",
    templates: {
      confirmationNeeded: {
        label: "Confirmation Needed",
        description: "Sent when asking a customer to confirm an order",
      },
      openDraftOrders: {
        label: "Open Draft Orders",
        description: "Sent when nudging a customer about a draft order",
      },
      checkoutRecovery: {
        label: "Checkout Recovery",
        description: "Sent when recovering an abandoned checkout",
      },
    },
  },
} as const;
